import { CatalogOperationVue } from "./CatalogOperationVue";
import { OperationPropertyModel } from "../../models/operations/operationPropertyModel";
import i18n from "@/i18n";


/**Модель представления операции */
export class CreditOperationVue extends CatalogOperationVue {

  async nextStep(): Promise<void> {
    this.OperationModel.Properties.forEach((prop: OperationPropertyModel) => { 
      if (prop.errorText.length > 0) {
        prop.errorText = '';
        prop.loadCheckRules();
      }
    });
    await this.next();
  }

  get confirmText(): string {
    return i18n.t("main.operation.form.depositOpenRules.confirmButton");
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    this.appStore.setLoading(true);
    if (this.OperationModel.IsSuccess) {
      this.alertService.success(i18n.t('main.operations.messages.creditSuccess'), false);
    } else if (this.OperationModel.IsError) {
      this.alertService.error(this.OperationModel.ActionStateText, false);
    } else if (this.OperationModel.IsExecuting) {
      this.alertService.warning(this.OperationModel.ActionStateText, false);
    }
    this.$router.push('/products');
  }
}
